import React, { Suspense } from "react";
import { AppBar, Box, Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import { AccountMenu } from "src/components/header/AccountMenu";
import ATMOPlanLogo from "src/assets/images/atmo-plan-logo-filled.png";
import { CaseLayoutTitle } from "src/components/CaseLayoutTitle";
import { LanguageMenu } from "src/components/header/LanguageMenu";
import { HelpMenu } from "src/components/header/HelpMenu";

interface Props {
  children: NonNullable<React.ReactNode>;
  toolbarChildren?: NonNullable<React.ReactNode>;
}
export function CaseLayout(props: Props) {
  const { caseId = ""} = useParams<{ caseId: string }>();

  return render();

  function render() {
    return (
      <Styles>
        <AppBar position="fixed" color="transparent" elevation={0} className="app-bar">
          <Toolbar className="toolbar">
            <div className="logo-brand">
              <img src={ATMOPlanLogo} alt="logo ATMOPlan" />
            </div>

            <CaseLayoutTitle caseId={caseId} />

            <Box flexGrow={1} />

            <div className="toolbar-children">{props.toolbarChildren}</div>

            <Suspense fallback="...">
              <LanguageMenu />
            </Suspense>
            <AccountMenu />
            <HelpMenu />
          </Toolbar>
        </AppBar>

        <main className="content">
          <div className="toolbar" />

          {props.children}
        </main>
      </Styles>
    );
  }
}

const Styles = styled("div")`
  display: flex;
  height: 100%;

  .app-bar {
    width: 100%;
  }

  .logo-brand {
    position: absolute;
    left: 0;
    top: 0;
    width: ${({ theme }) => theme.caseDrawer.width}px;
    height: 60px;
    border-right: 1px solid #e9e9e9;

    img {
      height: 100%;
    }
  }

  .toolbar {
    ${({ theme }) => ({ ...theme.mixins.toolbar })}
    align-items: center;
    min-height: 60px;
  }

  .toolbar-children {
    align-self: center;

    > * {
      margin-right: ${({ theme }) => theme.spacing(1)};
    }
  }

  .content {
    flex-grow: 1;
    overflow: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;
